// Mascot component — renders the SEO Revue falcon character in different poses
// Poses: binoculars, newspaper, lightbulb, watch, clipboard, waving

const POSES = {
  binoculars: "/mascot/binoculars.png",
  newspaper: "/mascot/newspaper.png",
  lightbulb: "/mascot/lightbulb.png",
  watch: "/mascot/watch.png",
  clipboard: "/mascot/clipboard.png",
  waving: "/mascot/waving.png",
};

export function Mascot({ pose = "waving", className = "w-32 h-32", alt, animate = false }) {
  const src = POSES[pose] || POSES.waving;
  return (
    <img
      src={src}
      alt={alt || `SEO Revue mascot — ${pose}`}
      className={`${className} object-contain select-none ${animate ? "bob" : ""}`}
      draggable={false}
    />
  );
}

export default Mascot;
